import React from 'react'
import { Outlet } from 'react-router-dom'
import Navbar from '../Components/Navbar'
import Footer from '../Components/Footer'

const HomeLayout = () => {
  return (
    <div className=''>
      <Navbar />
      <div className='my-4 min-h-screen'>
        <Outlet/>
      </div>
      <Footer />
    </div>
  )
}

export default HomeLayout